module.exports = __webpack_public_path__ + "960f5e504886aceeaa2057857bcdbad4.svg";